import { render } from "./RouteTable.vue?vue&type=template&id=4f208c09&scoped=true"
import script from "./RouteTable.vue?vue&type=script&lang=js"
export * from "./RouteTable.vue?vue&type=script&lang=js"

import "./RouteTable.vue?vue&type=style&index=0&id=4f208c09&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f208c09"]])

export default __exports__